import { Injectable } from '@angular/core';

@Injectable()
export class Creation {
    public _creation : any [] = [
        { value:0, name: 'TODOS' },
        { value:1, name: 'Este Mes' },
        { value:2, name: 'Esta Semana' },
        { value:3, name: 'Hoy' } ,
        { value:4, name: 'Ayer' } ,
        { value:5, name: 'Semana Pasada' } ,
        { value:6, name: 'Mes Pasado' } ,
        { value:7, name: 'Rango' } 
      ];

      public _newCreation : any [] = [
        { value:0, name: 'Hoy' } ,
        { value:1, name: 'Ayer' } ,
        { value:2, name: 'Esta semana' },
        { value:3, name: 'La semana pasada' },
        { value:4, name: 'Este mes' },
        { value:5, name: 'Mes pasado' },
        { value:6, name: 'Este año' },
        { value:7, name: 'Año pasado' },
        { value:8, name: 'Todo' }
      ];

    constructor() { }
  }

  
  @Injectable()
export class ExpirationRank {
    public _expirationRank : any [] = [
        { value:0, name: 'TODOS' },
        { value:1, name: 'Hoy' },
        { value:2, name: 'Mañana' } ,
        { value:3, name: 'Esta Semana' } ,
        { value:4, name: 'Este Mes' } ,
        { value:5, name: 'Rango' } 
      ];

    constructor() { }
  }


  @Injectable()
  export class Overduedate {
      public _overduedate : any [] = [
          { value:0, name: 'TODOS' },
          { value:1, name: 'Vencidos 90 días o más' },
          { value:2, name: 'Vencidos 60 días o más' } ,
          { value:3, name: 'Vencidos 30 días o más' } ,
          { value:4, name: 'Vencidos menos 30 días' } ,
          { value:5, name: 'Por vencer hoy' } ,
          { value:6, name: 'Por vencer esta semana' } ,
          { value:7, name: 'Por vencer este mes' } ,
          { value:8, name: 'Rango' } 

        ];
  
      constructor() { }
    }

          
    @Injectable()
    export class Status {
        public _status : any [] = [
            { value:0, name: 'TODOS' },
            { value:1, name: 'Pendientes'},
            { value:2, name: 'En Proceso'},
            { value:3, name: 'Pagados' } ,         
            { value:4, name: 'Anulados' } ,
            { value:5, name: 'Vencidos' } ,
            { value:6, name: 'Expirados' },
            { value:7, name: 'Rechazado' },
            { value:8, name: 'Revertido' },  
            { value:9, name: 'Pendiente validación' },
            { value:10, name: 'Validando' },
            { value:11, name: 'Bloqueada' },
            { value:12, name: 'En revisión' },
          ];
    
        constructor() { }
      }
                                                                            